import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { CmsService, PageMetaConfig, PageMetaService, UnifiedInjector } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KBPageMetaService extends PageMetaService {
  customBreadcrumbs$ = new BehaviorSubject<any[]>([]);

  constructor(
    protected override cms: CmsService,
    protected override unifiedInjector: UnifiedInjector,
    protected override pageMetaConfig: PageMetaConfig,
    @Inject(PLATFORM_ID) protected override platformId: string,
    protected router: Router
  ) {
    super(cms, unifiedInjector, pageMetaConfig, platformId);
    router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((_res) => {
      this.customBreadcrumbs$.next([]);
    });
  }
}
